import { Constants } from "@/libs/map-draw/lib-utils";
import {
  getPointFeatures,
  getLinkFeatures,
  createHoveredSPHelper,
  getStopPointsData,
  createStopPointsHelpers,
  removeStopPointsHelpers,
  removeHoveredSPHelpers,
  nearestPointOnLine,
  isPointInLinkArea
} from "@/libs/map-draw/helpers";

export const createDrawStopPointsMode = (MapboxDraw, editor, component) => {
  const DrawStopPoints = {};
  const customState = {
    hoveredFeatureId: "",
    no: "",
    fromnodeno: "",
    type: "",
    currentPoint: null,
    projectionPoint: null
  };

  DrawStopPoints.onMouseOut = function() {
    // removeStopPointsHelpers(this.map);
  };

  DrawStopPoints.onTap = DrawStopPoints.onClick = function(state) {
    const {
      hoveredFeatureId,
      currentPoint,
      projectionPoint,
      type
    } = customState;

    if (hoveredFeatureId && currentPoint) {
      const { coordinates } = projectionPoint;
      this.updateUIClasses({ mouse: Constants.cursors.MOVE });
      state.point.updateCoordinate("", coordinates[0], coordinates[1]);

      if (type === "link") {
        state.point.setProperty("link_id", hoveredFeatureId);
        // state.point.setProperty("fromnodeno", fromnodeno);
      } else {
        state.point.setProperty("node_id", hoveredFeatureId);
      }

      state.point.setProperty("stop_geom", customState.currentPoint);

      // attributes editing helper
      editor.creatingCallback = () => {
        removeStopPointsHelpers(this.map);
        this.map.fire(Constants.events.CREATE, {
          features: [state.point.toGeoJSON()]
        });
        this.changeMode(Constants.modes.SIMPLE_SELECT, {
          featureIds: [state.point.id]
        });
      };
      editor.activeObject = state.point;
      component.$store.commit("SET_PT_STATE_PROP", {
        name: "activeCard",
        value: true
      });
      component.$store.commit("SET_PT_STATE_PROP", {
        name: "overlay",
        value: true
      });
    }
  };

  DrawStopPoints.onMouseMove = function(state, e) {
    const { lng, lat } = e.lngLat;
    const nodesFeatures = getPointFeatures(this.map, editor, e, "nodes");
    const linksFeatures = getLinkFeatures(this.map, editor, e);

    if (nodesFeatures.length) {
      const feature = nodesFeatures[0];
      const { coordinates } = feature.geometry;

      if (customState.hoveredFeatureId !== feature.properties.id) {
        removeStopPointsHelpers(this.map);
        customState.hoveredFeatureId = "";

        createHoveredSPHelper(this.map, coordinates);
        const { id, no } = feature.properties;
        customState.hoveredFeatureId = id;
        customState.currentPoint = {
          type: "Point",
          coordinates
        };
        customState.projectionPoint = {
          type: "Point",
          coordinates
        };
        customState.type = "node";
        customState.no = no;
      }
    } else if (linksFeatures.length) {
      const link = linksFeatures.find(l =>
        isPointInLinkArea([lng, lat], l.geometry.coordinates, 100)
      );

      if (link) {
        removeHoveredSPHelpers(this.map);
        const nearest = nearestPointOnLine(
          [lng, lat],
          link.geometry.coordinates
        );
        const current = {
          geometry: {
            type: "Point",
            coordinates: [lng, lat]
          },
          properties: {
            projection: "true"
          }
        };
        const connection = {
          geometry: {
            type: "LineString",
            coordinates: [nearest.geometry.coordinates, [lng, lat]]
          }
        };

        const { id, no, fromnodeno } = link.properties;
        customState.hoveredFeatureId = id;
        customState.type = "link";
        customState.no = no;
        customState.fromnodeno = fromnodeno;
        customState.currentPoint = current.geometry;
        customState.projectionPoint = nearest.geometry;

        const data = getStopPointsData(nearest, current, connection);
        createStopPointsHelpers(this.map, data);
      } else {
        removeStopPointsHelpers(this.map);
        customState.hoveredFeatureId = "";
        customState.type = "";
        customState.currentPoint = null;
        customState.projectionPoint = null;
      }
    } else {
      removeStopPointsHelpers(this.map);
      customState.hoveredFeatureId = "";
      customState.type = "";
      customState.currentPoint = null;
      customState.projectionPoint = null;
    }
  };

  return { ...MapboxDraw.modes.draw_point, ...DrawStopPoints };
};
